import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen flex items-center justify-center pt-16 bg-background-50">
        <div className="text-center px-4">
          <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-300">
            <i className="ri-compass-discover-line text-5xl"></i>
          </div>
          <h1 className="font-heading text-5xl font-bold text-foreground-950 mb-3">404</h1>
          <p className="text-lg text-foreground-600 mb-2">页面未找到</p>
          <p className="text-sm text-foreground-500 mb-8 max-w-md mx-auto">
            您访问的页面不存在或已被移除，请检查地址是否正确或返回首页继续浏览。
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-lg font-medium transition-colors whitespace-nowrap"
          >
            <i className="ri-home-3-line"></i>
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}